<template>
  <v-card outlined>
    <v-card-title>
      <h2>Personal details</h2>
    </v-card-title>
    <v-card-subtitle>
      Enter your details to create a personal account on AuthentiGate.
    </v-card-subtitle>
    <v-form
      ref="form"
      data-testid="sign-up-single-user-account-form"
      @submit.prevent="submit"
    >
      <v-card-text>
        <v-text-field
          v-model="email"
          :error-messages="emailErrors"
          label="Email"
          type="email"
          @input="$v.email.$touch()"
          @blur="$v.email.$touch()"
        />
        <v-text-field
          v-model="firstName"
          :error-messages="firstNameErrors"
          label="First name"
          @input="$v.firstName.$touch()"
          @blur="$v.firstName.$touch()"
        />
        <v-text-field
          v-model="lastName"
          :error-messages="lastNameErrors"
          label="Last name"
          @input="$v.lastName.$touch()"
          @blur="$v.lastName.$touch()"
        />
        <v-text-field
          v-model="password"
          :error-messages="passwordErrors"
          label="Password"
          type="password"
          @input="$v.password.$touch()"
          @blur="$v.password.$touch()"
        />
        <accept-terms v-model="termsAccepted" />
      </v-card-text>
      <div class="sign-up">
        <v-btn
          x-large
          block
          color="primary"
          type="submit"
          :disabled="formInvalid"
          :loading="loading"
        >
          Sign up
        </v-btn>
      </div>
    </v-form>
  </v-card>
</template>
<script>
import SubmitUserSignUp from '@/mixins/SubmitUserSignUp'
import { validationMixin } from 'vuelidate'
import { email, minLength, required } from 'vuelidate/lib/validators'
import { SINGLE_USER } from '@/dataAccess/accountTypes'
import AcceptTerms from '@/components/AcceptTerms'

export default {
  name: 'SignUpSingleUserAccount',
  components: { AcceptTerms },
  mixins: [SubmitUserSignUp, validationMixin],
  data() {
    return {
      email: null,
      firstName: null,
      lastName: null,
      password: null,
      loading: false,
      termsAccepted: false
    }
  },
  computed: {
    formInvalid() {
      return this.$v.$invalid || !this.termsAccepted
    },
    emailErrors() {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push('Must be valid email')
      !this.$v.email.required && errors.push('Email is required')
      return errors
    },
    firstNameErrors() {
      const errors = []
      if (!this.$v.firstName.$dirty) return errors
      !this.$v.firstName.required && errors.push('First name is required')
      return errors
    },
    lastNameErrors() {
      const errors = []
      if (!this.$v.lastName.$dirty) return errors
      !this.$v.lastName.required && errors.push('Last name is required')
      return errors
    },
    passwordErrors() {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('Password is required')
      !this.$v.password.minLength &&
        errors.push(
          `Password must have at least ${this.$v.password.$params.minLength.min} characters`
        )
      return errors
    }
  },
  validations: {
    email: { required, email },
    firstName: { required },
    lastName: { required },
    password: { required, minLength: minLength(7) }
  },
  methods: {
    async submit() {
      this.loading = true
      await this.submitUserSignUp(SINGLE_USER.id, {
        name: `${this.firstName} ${this.lastName}`,
        email: this.email,
        password: this.password,
        termsAccepted: this.termsAccepted
      })
      this.loading = false
    }
  }
}
</script>

<style scoped></style>
